import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';

import { trackDataSelector, highlightedDriveSelector, highlightedStopSelector } from '../../../features/datacenter/historySlice';
import { gensetTrackReportIdSelector, gensetViewportPaddingSelector, setNeedBounding } from '../../../features/map/mapSlice';

const OsmGensetTrackBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const reportId = useSelector(gensetTrackReportIdSelector);
    const trackData = useSelector(trackDataSelector);
    const highlightedDrive = useSelector(highlightedDriveSelector);
    const highlightedStop = useSelector(highlightedStopSelector);
    const viewportPadding = useSelector(gensetViewportPaddingSelector);

    useEffect(() => {
        if (!map || !reportId) return;
        const track = trackData?.[reportId]?.track || [];
        if (!track.length) return;
        const padding = viewportPadding
            ? {
                paddingTopLeft: [Math.max(0, viewportPadding.left || 0), Math.max(0, viewportPadding.top || 0)],
                paddingBottomRight: [Math.max(0, viewportPadding.right || 0), Math.max(0, viewportPadding.bottom || 0)],
            }
            : { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] };
        if (highlightedDrive?.startIndex !== null && highlightedDrive?.endIndex !== null) {
            const bounds = [];
            track.forEach((point, index) => {
                if (index >= highlightedDrive.startIndex && index <= highlightedDrive.endIndex) {
                    bounds.push([point.lat, point.lng]);
                }
            });
            if (bounds.length) {
                map.fitBounds(bounds, padding);
                dispatch(setNeedBounding(false));
                return;
            }
        }
        if (highlightedStop?.startIndex !== null) {
            const point = track[highlightedStop.startIndex];
            if (point) {
                map.fitBounds([[point.lat, point.lng], [point.lat, point.lng]], padding);
                dispatch(setNeedBounding(false));
                return;
            }
        }
        const bounds = track.map((point) => [point.lat, point.lng]);
        map.fitBounds(bounds, padding);
        dispatch(setNeedBounding(false));
    }, [dispatch, highlightedDrive, highlightedStop, map, reportId, trackData, viewportPadding]);

    return null;
};

export default OsmGensetTrackBounder;
